import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { Card, CardContent, CardHeader, createStyles, WithStyles, withStyles } from '@material-ui/core';
import { RootState } from '@store/reducers';

import { LoginForm } from './LoginForm';

export interface LoginPageProps {
  notifications: any;
}

interface LoginPagePrivateProps extends WithStyles, LoginPageProps {}

const styles = () =>
  createStyles({
    container: {
      width: 300,
    },
  });

const LoginPage: React.FunctionComponent<LoginPagePrivateProps> = ({ classes }) => {
  return (
    <div>
      <Card className={classes.container}>
        <CardHeader title="Please login" />
        <CardContent>
          <LoginForm />
        </CardContent>
      </Card>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  notifications: state.notifications,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(LoginPage);
